import type { QueryClient } from '@tanstack/react-query';
import { JournalQueryKeys } from '../journal/journalQueryKeys';
import { StatementQueryKeys } from '../statements/statementQueryKeys';
import { PeriodQueryKeys } from './periodQueryKeys';

/**
 * Everything a close, reopen or rollover moves.
 *
 * A close is a journal entry, so it changes three screens at once and all three
 * must be dropped together:
 *
 * - **periods** — the statuses that just changed, and the previews derived from
 *   them (a posted close makes its own preview stale);
 * - **journal** — the CLOSING / ROLLOVER / reversing entry now exists, and the
 *   Journal Entry form's date gate reads period status;
 * - **statements** — equity's `RESULT_FOR_PERIOD` reflects the closing entry.
 *   (The P&L deliberately excludes it; refetching is still correct, the backend
 *   simply returns the same figures.)
 */
export const invalidateAfterPeriodWrite = (queryClient: QueryClient): void => {
    queryClient.invalidateQueries({ queryKey: PeriodQueryKeys.all });
    queryClient.invalidateQueries({ queryKey: JournalQueryKeys.all });
    queryClient.invalidateQueries({ queryKey: StatementQueryKeys.all });
};
